module.exports = __webpack_public_path__ + "img/logo.e0031d3d.jpg";